import React,{useEffect, useState} from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom';
import { searchScreenData } from '../../../../services/searchScreenData';
import AdminDashboardUsersDetails from '../AdminDashboardUsersDetails/AdminDashboardUsersDetails';
import AdminDashboardUsersTable from '../AdminDashboardUsersTable/AdminDashboardUsersTable'
import { useSelector } from 'react-redux'
import { getToken } from '../../../../features/token/tokenSaver';
import { searchUserData } from '../../../../services/searchUserData';
export default function AdminDashboardUsersHome(props) {
  const navigate = useNavigate();
  const [searchItems, setSearchItems] = useState(null);
  const [details, setScreenDetails] = useState(false);
  const [screenId, setScreenId] = useState(null);
  const [lastSearched, setLastSearched] = useState("");
  const token = useSelector(getToken)

    useEffect(() => {
    
      return () => {
        
      }
    }, [])
  function searchHandler(e) {
    if (e.keyCode == 13 && lastSearched !== e.target.value && !e.target.value.match(/^\s*$/)) {
      searchUserData(token, e.target.value).then(response => {
        setSearchItems(response.data.users);
        setLastSearched(e.target.value);
      })
    }
    else if (e.target.value.match(/^\s*$/)){
      setSearchItems(null);
    }
  }
  function screenDetails(screenId) {
    setScreenId(screenId);
    setScreenDetails(true);
  }
  function screensTable() {
    setScreenDetails(false);
  }
    return (
      <div className='AdminDashboardUsersPageContainer'>
        {!details &&<div className='AdminDashboardUsersTable'>
          <span className='registeredScreensTitle'>Registered Users</span>
          <div style={{ marginBottom: '12px' }}>
            <button
              type="button"
              className="advertiserEditActionBtn"
              onClick={() => navigate('/adminDashboard/users/hosts')}
            >
              Screen host accounts
            </button>
            <button
              type="button"
              className="advertiserEditActionBtn"
              style={{ marginLeft: '8px' }}
              onClick={() => navigate('/adminDashboard/users/create')}
            >
              + Register screen host
            </button>
          </div>
          <input onKeyUp={(e) => { searchHandler(e); }} type={"text"} placeholder='Search' className='AdminDashboardUsersPageSearchInput' />
          <AdminDashboardUsersTable screenDetails={screenDetails} data={searchItems}></AdminDashboardUsersTable>
        </div>
        }
        {details &&
          <AdminDashboardUsersDetails screensTable={screensTable}screenId={screenId}></AdminDashboardUsersDetails>
        
        }
        </div>
  )
}
